class ReviewsBanner extends HTMLElement {
  constructor() {
    super();
    this.hiddenReviews = document.querySelectorAll(".review-hidden");
    this._init();
  }

  _init() {
    const showAllBtn = this.querySelector(".review-banner__show-all-btn");
    if (showAllBtn) {
      showAllBtn.addEventListener("click", () => {
        this.toggleAllReviews();
      });
    }
    if (!this.classList.contains("has-slider")) {
      return;
    }
    this.randNum = Math.floor(Math.random() * 1000000);
    this.swiper = null;
    this._initSwiper = this._initSwiper.bind(this);
    this._sectionrenderLogic();
  }

  _sectionrenderLogic() {
    const swiperEl = this.querySelector(".review-banner__reviews-swiper");
    if (!swiperEl) return;

    const initSwiper = () => {
      const isAboveFold = this.getBoundingClientRect().top < window.innerHeight;

      if (isAboveFold) {
        window.swiperLoader.initImmediately(this._initSwiper);
      } else {
        const viewportHeight = window.innerHeight;
        window.swiperLoader.initWhenVisible(this, this._initSwiper, {
          rootMargin: `${viewportHeight}px`,
          threshold: 0.1,
        });
      }
    };

    if (window.swiperLoader) {
      initSwiper();
    } else {
      window.addEventListener("swiperloader:ready", initSwiper, { once: true });
    }

    window.addEventListener("resize", () => {
      if (this.swiper && window.Swiper) {
        this._initSwiper(window.Swiper);
      }
    });
  }

  _initSwiper(Swiper) {
    if (!Swiper) return;

    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    const swiperEl = this.querySelector(".review-banner__reviews-swiper");
    if (!swiperEl) return;
    swiperEl.classList.add(`swiper-${this.randNum}`);
    const swiperNext = this.querySelector(".swiper-btn-next");
    const swiperPrev = this.querySelector(".swiper-btn-prev");
    if (swiperNext) {
      swiperNext.classList.add(`swiper-${this.randNum}-next`);
    }
    if (swiperPrev) {
      swiperPrev.classList.add(`swiper-${this.randNum}-prev`);
    }
    this.swiper = new Swiper(this.querySelector(`.swiper-${this.randNum}`), {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      navigation: {
        nextEl: `.swiper-${this.randNum}-next`,
        prevEl: `.swiper-${this.randNum}-prev`,
      },
    });
  }
  toggleAllReviews() {
    const hiddenReviews = this.hiddenReviews;
    const button = document.querySelector(".review-banner__show-all-btn");
    const buttonText = button.querySelector(".review-banner__show-all-text");
    const chevron = button.querySelector(".review-banner__chevron");

    if (
      hiddenReviews.length > 0 &&
      hiddenReviews[0].classList.contains("review-hidden")
    ) {
      hiddenReviews.forEach((review) => {
        review.classList.remove("review-hidden");
      });
      buttonText.textContent = "Show less";
      chevron.style.transform = "rotate(180deg)";
      button.style.flexDirection = "column-reverse";
    } else {
      hiddenReviews.forEach((review) => {
        review.classList.add("review-hidden");
      });
      buttonText.textContent = "See all reviews";
      chevron.style.transform = "rotate(0deg)";
      button.style.flexDirection = "column";
    }
  }
}
customElements.define("reviews-banner", ReviewsBanner);
